module.exports = __webpack_public_path__ + "media/images/icons/search-icon-1a179517f67f946d4de969782945bfc6.svg";